<template>
    <div class="v-car">
        <Header></Header>
        <Navigation></Navigation>
        <div class="v-car__content container">
            <div class="flex-row">
                <div class="flex-col">
                    <SelectCar></SelectCar>
                </div>
                <div class="flex-col flex-col--4 ml--3">
                <Summary></Summary>
                </div>
            </div>
        </div>
        <Footer></Footer>
    </div>
</template>
<script>
    import Footer from '@/components/footer.vue'
    import Header from '@/components/header.vue'
    import Navigation from "@/components/navigation";

    import Summary from "@/components/services/summary";
    import SelectCar from "@/components/car/selectCar";

    export default {
        components:{
            Footer,
            Header,
            Navigation,
            Summary,
            SelectCar
        }
    }
</script>
<style lang="scss">
    .v-car{
        &__content{
            min-height: 90vh;
        }
    }
</style>